// extracted by mini-css-extract-plugin
export default {"jiraAttachmentItem":"_PvhluajJtlLPNhdcNoV","jiraLogo":"A1nKOCuFSGT6Niqjc1_9","jiraAttachmentLink":"orppFnD0qCeabqLHNIhu","jiraStatusTag":"kCCY7ciQD7BPCb4i_SAD"};